/*
  Caprino Animasyonları — tek dosya, kütüphanesiz.
  Ayarlar: Tema Editörü > Tema ayarları > Caprino Animasyonları (window.caprinoAnim).
  Kurallar: yalnızca transform/opacity, sepet ve ödeme sayfasında çalışmaz,
  "hareketi azalt" açık kullanıcıda hiçbir şey yapmaz.
*/
(function () {
  var cfg = window.caprinoAnim || {};
  if (!cfg.on) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  if (cfg.cardZoom && finePointer) root.classList.add('cp-card-zoom');

  /* 1a. Hero parallax: yalnızca hero görünürken, rAF ile */
  function heroParallax() {
    var heroes = document.querySelectorAll('.image-hero');
    heroes.forEach(function (hero) {
      var img = hero.querySelector('.image-hero__image-container .image__img');
      if (!img) return;
      hero.classList.add('cp-parallax');
      var strength = isMobile ? 0.08 : 0.18;
      var visible = false, ticking = false;
      function update() {
        ticking = false;
        var r = hero.getBoundingClientRect();
        // hero üstten çıktıkça görsel yavaşça aşağı kayar
        var y = Math.max(-r.top, 0) * strength;
        img.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(1.12)';
      }
      function onScroll() { if (visible && !ticking) { ticking = true; requestAnimationFrame(update); } }
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) onScroll(); }).observe(hero);
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    });
  }

  /* 1b. Hero başlığı satır satır: kelimeleri sarar, satırını offsetTop ile bulur */
  function heroLines() {
    var els = document.querySelectorAll('.image-hero .section-blocks__heading, .image-hero .section-blocks__subheading, .image-hero .section-blocks__accent');
    if (!els.length) return;
    var lineIndex = 0;
    els.forEach(function (el) {
      if (!el.textContent.trim() || el.querySelector('.cp-w')) return;
      // yalnızca düz metin düğümlerini kelimelere böl; bağlantı/etiketlere dokunma
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (n) {
        var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
        parts.forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
          var s = document.createElement('span'); s.className = 'cp-w'; s.textContent = p; frag.appendChild(s);
        });
        n.parentNode.replaceChild(frag, n);
      });
      var words = el.querySelectorAll('.cp-w'), lastTop = null;
      words.forEach(function (w) {
        var t = w.offsetTop;
        if (lastTop !== null && Math.abs(t - lastTop) > 4) lineIndex++;
        lastTop = t;
        w.style.setProperty('--cp-line', lineIndex);
      });
      lineIndex++;
      el.classList.add('cp-lines');
    });
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('cp-lines-in'); }); });
  }

  /* 4. Ürün görselinde masaüstü hover-zoom (mobilde temanın lightbox'ı var) */
  function productZoom() {
    if (!finePointer) return;
    document.querySelectorAll('.product__media .media--has-lightbox').forEach(function (m) {
      var img = m.querySelector('.image__img');
      if (!img) return;
      m.classList.add('cp-zoom');
      m.addEventListener('mousemove', function (e) {
        var r = m.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
      });
      m.addEventListener('mouseenter', function () { m.classList.add('is-zoom'); });
      m.addEventListener('mouseleave', function () { m.classList.remove('is-zoom'); });
    });
  }

  /* 5. Başlık: aşağı kaydırınca tamamen yukarı kayar, yukarı kaydırınca geri gelir */
  function headerDim() {
    var groups = document.querySelectorAll('.shopify-section-group-header-group');
    if (!groups.length) return;
    var lastY = window.scrollY, ticking = false;
    function height() { var h = 0; groups.forEach(function (g) { h += g.offsetHeight; }); return h; }
    function update() {
      ticking = false;
      var y = window.scrollY, dy = y - lastY;
      var h = height();
      if (y < h + 40 || dy < -6) root.classList.remove('cp-head-hide');
      else if (dy > 6 && !document.querySelector('.shopify-section-group-header-group:focus-within')) {
        root.style.setProperty('--cp-head-h', h + 'px');
        root.classList.add('cp-head-hide');
      }
      if (Math.abs(dy) > 6) lastY = y;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  }

  /* 2. Bölüm girişleri: yalnızca ilk ekranın ALTINDAKİ bölümler (LCP'yi etkilemez, tek seferlik) */
  function sectionReveal() {
    if (!('IntersectionObserver' in window)) return;
    var skip = /header-group|footer-group|caprino-sticky-buy|caprino-story|main-product/;
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('cp-in'); io.unobserve(e.target);
        // geçiş bitince sınıfları kaldır: transform kalmasın (sticky/fixed içerikleri bozmasın)
        setTimeout(function () { e.target.classList.remove('cp-rv', 'cp-in'); }, 900);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('main .shopify-section, #MainContent > .shopify-section, body > .shopify-section').forEach(function (s) {
      if (skip.test(s.className) || skip.test(s.id)) return;
      if (s.getBoundingClientRect().top < vh) return;   // ilk ekrandakilere dokunma
      s.classList.add('cp-rv'); io.observe(s);
    });
  }

  /* 6. Filtre çubuğu yapışınca .cp-stuck (alt gölge yalnızca yapışıkken) */
  function stickyBar() {
    var bars = document.querySelectorAll('.mobile-filters--sticky, .filter-bar--sticky');
    if (!bars.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      bars.forEach(function (b) {
        var t = parseFloat(getComputedStyle(b).top) || 0;
        b.classList.toggle('cp-stuck', window.scrollY > 0 && b.getBoundingClientRect().top <= t + 1);
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function start() {
    stickyBar();
    if (cfg.sections) sectionReveal();
    if (cfg.headerDim) headerDim();
    if (cfg.heroParallax) heroParallax();
    if (cfg.productZoom) productZoom();
    if (cfg.heroText) {
      // satırlar yazı tipi yüklendikten sonra ölçülmeli, yoksa satır kırılımı değişir
      (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(heroLines);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
